import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
// HOOKS
import useDevice from 'hooks/useDevice';

const Greeting = ({ message }) => {
  const { mobile } = useDevice();
  return (
    <h2
      className={classnames('title-combos flex ttu justify-center', {
        mobile: mobile,
      })}>
      <span className="normal title-form-main-mobile w-100 field-max-width">
        Assine Já
      </span>
      <span className="normal title-form-main-desktop w-100 field-max-width">
        {message.map((line, lineNumber) => {
          if (lineNumber > 0) {
            return (
              <span key={lineNumber}>
                <br />
                {line}
              </span>
            );
          }

          return <span key={lineNumber}>{line}</span>;
        })}
      </span>
    </h2>
  );
};

Greeting.propTypes = {
  message: PropTypes.array,
};

export default Greeting;
